import type { CopyFeedbackHandler } from "../hooks/useCopyFeedback";

const listeners = new Set<CopyFeedbackHandler>();

export function subscribeToCopyFeedback(
  listener: CopyFeedbackHandler,
): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function emitCopyFeedback(
  status: Parameters<CopyFeedbackHandler>[0],
  message: Parameters<CopyFeedbackHandler>[1],
) {
  if (listeners.size === 0) {
    return;
  }
  listeners.forEach((listener) => {
    try {
      listener(status, message);
    } catch (error) {
      console.error("Copy feedback listener failed", error);
    }
  });
}

export function emitCopySuccess(message: string) {
  emitCopyFeedback("success", message);
}

export function emitCopyError(message: string) {
  emitCopyFeedback("error", message);
}
